import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {
  const [isDarkMode, setIsDarkMode] = useState(false);

  const toggleDarkMode = () => {
    setIsDarkMode(!isDarkMode);
    document.documentElement.classList.toggle('dark');
  };

  return (
    <nav className="bg-royal-blue text-white p-4 dark:bg-dark-bg dark:text-dark-text">
      <div className="container mx-auto flex justify-between items-center">
        {/* Logo */}
        <div className="flex items-center space-x-2">
          <img
            src="/logo.png"
            alt="Ekul Consulting Logo"
            className="w-10 h-10 rounded-full"
          />
          <Link to="/" className="text-xl font-bold">Ekul Consulting</Link>
        </div>

        {/* Navigation Links */}
        <div className="space-x-4">
          <Link to="/jobs" className="hover:text-cyan">Jobs</Link>
          <Link to="/about-us" className="hover:text-cyan">About Us</Link>
          <Link to="/services" className="hover:text-cyan">Services</Link>
          <Link to="/contact" className="hover:text-cyan">Contact</Link>
          <Link to="/login" className="hover:text-cyan">Login</Link>
          <Link to="/register" className="hover:text-cyan">Register</Link>
        </div>

        {/* Dark Mode Toggle */}
        <button
          onClick={toggleDarkMode}
          className="bg-cyan text-white px-4 py-2 rounded hover:bg-blue-700"
        >
          {isDarkMode ? 'Light Mode' : 'Dark Mode'}
        </button>
      </div>
    </nav>
  );
};

export default Navbar;